import type { LucideIcon } from "lucide-react-native";
import {
  Search,
  Sparkles,
  Snowflake,
  MoreHorizontal,
  Bug,
  Zap,
  ShieldAlert,
  Pill,
  Shield,
  Heart,
  Flame,
  AlertTriangle,
  Clock,
  ThumbsDown,
} from "lucide-react-native";

// ── Pap smear procedure types ──────────────────────────────
export type PapSmearProcedureType =
  | "colposcopy"
  | "laser_treatment"
  | "cryotherapy"
  | "other";

export const PAP_SMEAR_PROCEDURE_OPTIONS: {
  id: PapSmearProcedureType;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "colposcopy",
    labelKey: "med_history.gynae.sexual_health.pap_smear_procedure.colposcopy",
    icon: Search,
  },
  {
    id: "laser_treatment",
    labelKey:
      "med_history.gynae.sexual_health.pap_smear_procedure.laser_treatment",
    icon: Sparkles,
  },
  {
    id: "cryotherapy",
    labelKey: "med_history.gynae.sexual_health.pap_smear_procedure.cryotherapy",
    icon: Snowflake,
  },
  {
    id: "other",
    labelKey: "med_history.gynae.sexual_health.pap_smear_procedure.other",
    icon: MoreHorizontal,
  },
];

// ── STD types ──────────────────────────────────────────────
export type STDType =
  | "syphilis"
  | "gonorrhea"
  | "chlamydia"
  | "hpv"
  | "hepatitis"
  | "hiv"
  | "genital_herpes"
  | "trichomonas_vaginalis"
  | "other";

export const STD_OPTIONS: {
  id: STDType;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "syphilis",
    labelKey: "med_history.gynae.sexual_health.std.syphilis",
    icon: Bug,
  },
  {
    id: "gonorrhea",
    labelKey: "med_history.gynae.sexual_health.std.gonorrhea",
    icon: Zap,
  },
  {
    id: "chlamydia",
    labelKey: "med_history.gynae.sexual_health.std.chlamydia",
    icon: ShieldAlert,
  },
  {
    id: "hpv",
    labelKey: "med_history.gynae.sexual_health.std.hpv",
    icon: AlertTriangle,
  },
  {
    id: "hepatitis",
    labelKey: "med_history.gynae.sexual_health.std.hepatitis",
    icon: Pill,
  },
  {
    id: "hiv",
    labelKey: "med_history.gynae.sexual_health.std.hiv",
    icon: Shield,
  },
  {
    id: "genital_herpes",
    labelKey: "med_history.gynae.sexual_health.std.genital_herpes",
    icon: Flame,
  },
  {
    id: "trichomonas_vaginalis",
    labelKey: "med_history.gynae.sexual_health.std.trichomonas_vaginalis",
    icon: Heart,
  },
  {
    id: "other",
    labelKey: "med_history.gynae.sexual_health.std.other",
    icon: MoreHorizontal,
  },
];

// ── Vaginal infection frequency ────────────────────────────
export type VaginalInfectionFrequency = "often" | "past" | "none";

export const VAGINAL_INFECTION_OPTIONS: {
  id: VaginalInfectionFrequency;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "often",
    labelKey: "med_history.gynae.sexual_health.vaginal_infection.often",
    icon: AlertTriangle,
  },
  {
    id: "past",
    labelKey: "med_history.gynae.sexual_health.vaginal_infection.past",
    icon: Clock,
  },
  {
    id: "none",
    labelKey: "med_history.gynae.sexual_health.vaginal_infection.none",
    icon: ThumbsDown,
  },
];

// ── Frequency type (shared for lubricants & ejaculation) ───
export type FrequencyType = "rarely" | "sometimes" | "often";

export const FREQUENCY_OPTIONS: {
  id: FrequencyType;
  labelKey: string;
}[] = [
  {
    id: "rarely",
    labelKey: "med_history.gynae.sexual_health.frequency.rarely",
  },
  {
    id: "sometimes",
    labelKey: "med_history.gynae.sexual_health.frequency.sometimes",
  },
  {
    id: "often",
    labelKey: "med_history.gynae.sexual_health.frequency.often",
  },
];
